<template>
	<main class="main">
		<h1 class="heading">
			<div class="heading__title">Matthew A. Steven</div>
			<div class="heading__subtitle">
				masteve@g.clemson.edu • (864) 608-1101<br>
				Columbia, SC
			</div>
		</h1>
		<div class="resume container container--large">
			<div class="row">
				<div class="column column--sm-12 column--3">
					<h2 class="heading heading--subsection">
						<div class="heading__title">Objective</div>
					</h2>
				</div>
				<div class="column column--sm-12 column--9">
					<p>To find full time employment opportunity in web development that will utilize my skill sets in both art and programming</p>
				</div>
			</div>
			<div class="row">
				<div class="column column--sm-12 column--3">
					<h2 class="heading heading--subsection">
						<div class="heading__title">Education</div>
					</h2>
				</div>
				<div class="column column--sm-12 column--9">
					<h3 class="heading heading--trisection">
						<div class="heading__title">Clemson University</div>
						<div class="heading__subtitle">BA - Computer Science Major; Digital Production Arts Minor | 2013</div>
					</h3>
				</div>
			</div>
			<div class="row">
				<div class="column column--sm-12 column--3">
					<h2 class="heading heading--subsection">
						<div class="heading__title">Employment</div>
					</h2>
				</div>
				<div class="column column--sm-12 column--9">
					<h3 class="heading heading--trisection">
						<div class="heading__title">Blue Cross Blue Shield of South Carolina</div>
						<div class="heading__subtitle">User Experience Team; Front End Developer / Web Designer | May 2013 - present</div>
					</h3>
					<ul class="list">
						<li>
							Developed and coordinated implementation of the company's time-keeping system website
						</li>
						<li>
							Developed ACA health care cost estimation and enrollment website utilizing the Dojo Tookit
						</li>
						<li>
							Created a drag and drop prototyping tool to allow some front-end code to be generated from the prototyping process
						</li>
						<li>
							Developed and published the company's first mobile app for iOS and Android written using the Ionic framework
						</li>
					</ul>
					<h3 class="heading heading--trisection">
						<div class="heading__title">Clemson University</div>
						<div class="heading__subtitle">UPIC Internship, Clemson Libraries Web Designer | Spring 2013</div>
					</h3>
					<ul class="list">
						<li>
							Designed a proposed layout and overall look of Clemson's new library website
						</li>
						<li>
							Provided input on content organization, functionality, and created a prototype for new website
						</li>
					</ul>
					<h3 class="heading heading--trisection">
						<div class="heading__title">Clemson University</div>
						<div class="heading__subtitle">Computer Lab Assistant (Work Study) | Spring 2012 - Fall 2012</div>
						<div class="heading__subtitle">Clemson HEHD Computer Technical Support (Work Study) | Fall 2009 - Spring 2010</div>
					</h3>
				</div>
			</div>
			<div class="row">
				<div class="column column--sm-12 column--3">
					<h2 class="heading heading--subsection">
						<div class="heading__title">Skill Sets</div>
					</h2>
				</div>
				<div class="column column--sm-12 column--9">
					<div class="row">
						<div class="column column--sm-12 column--6">
							<h3 class="heading heading--trisection">
								<div class="heading__title">Languages</div>
							</h3>
							<ul class="list">
								<li>
									HTML5 with WAI-ARIA Accessibility
								</li>
								<li>
									CSS3/BEM via SASS or LESS
								</li>
								<li>
									Javascript (ES8), Typescript
								</li>
								<li>
									LAMP Stack (Linux, Apache, MySQL, PHP)
								</li>
								<li>
									C, C++, OpenGL
								</li>
								<li>
									XML, JSON, YAML
								</li>
							</ul>
						</div>
						<div class="column column--sm-12 column--6">
							<h3 class="heading heading--trisection">
								<div class="heading__title">Tools</div>
							</h3>
							<ul class="list">
								<li>
									Adobe Creative Suite (Photoshop, Illustrator)
								</li>
								<li>
									Visual Studio Code
								</li>
								<li>
									Git (GitHub, GitLab), CA Harvest
								</li>
								<li>
									Node.js, Webpack
								</li>
								<li>
									Blender
								</li>
								<li>
									GIMP
								</li>
								<li>
									JFrog
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="column column--sm-12 column--3">
					<h2 class="heading heading--subsection">
						<div class="heading__title">Professional Development</div>
					</h2>
				</div>
				<div class="column column--sm-12 column--9">
					<h3 class="heading heading--trisection">
						<div class="heading__title">ConvergeSE Conference</div>
						<div class="heading__subtitle">Classes Attended for 2 days | Oct 2015</div>
					</h3>
					<h3 class="heading heading--trisection">
						<div class="heading__title">Midlands Technical College Northeast</div>
						<div class="heading__subtitle">IBM Websphere Training | July 2013</div>
					</h3>
					<h3 class="heading heading--trisection">
						<div class="heading__title">BCBS Entry Level Training Program</div>
						<div class="heading__subtitle">Javascript, HTML, CSS, Java | June 2013 - Aug 2013</div>
					</h3>
				</div>
			</div>
			<div class="row">
				<div class="column column--sm-12 column--3">
					<h2 class="heading heading--subsection">
						<div class="heading__title">Awards, Scholarships, Honors</div>
					</h2>
				</div>
				<div class="column column--sm-12 column--9">
					<p>Clemson University President's List; Computer Graphics Teapot Award; Watson-Brown Scholar; Sirrine Scholar; Marine Corps Scholar; Second Marine Division Scholar; South Carolina State Elks Lodge Scholar; SC Life Scholar; BSA Eagle Scout</p>
				</div>
			</div>
			<div class="row">
				<div class="column column--sm-12 column--3">
					<h2 class="heading heading--subsection">
						<div class="heading__title">References</div>
					</h2>
				</div>
				<div class="column column--sm-12 column--9">
					<p>Available upon request</p>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
	export default {
		name: 'HomePage',
		data() {
			return {
				
			};
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/ResumePage.vue